module.exports = "/lucky-balls/img/video.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/video.png
// module id = 1155
// module chunks = 0